import { Dialog, DialogContent, Typography } from "@mui/material";
import { MprcDialogTitleClose } from "components";
import { DiscussionListFilter } from "generated/CoreApi_v1";
import { useTranslation } from "react-i18next";
import { ClassroomDiscussionBox, IClassroomDiscussionProps } from "./ClassroomDiscussionBox";

/////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    trainingName: string;
    classroomName?: string;
    initialListFilter?: DiscussionListFilter;
    onClose: () => void;
    onUpdateCommentCounter?: (totalComments: number) => void;
}

type Props = Omit<IClassroomDiscussionProps, "discussionMode" | "onUpdateCommentCounter"> & IProps;

/////////////////////////////////////////////////////////////////////////////////////

export const ClassroomDiscussionDialog: React.FC<Props> = (props) => {

    const { onClose, onUpdateCommentCounter, ...rest } = props;
    const { t } = useTranslation("lms");

    return (
        <Dialog
            open={true}
            fullWidth
            maxWidth="md"
            onClose={() => onClose}
        >
            <MprcDialogTitleClose
                title={
                    <>
                        {t("Classroom.ClassroomDiscussionDialog.Title")} <br />
                        <Typography variant="caption" sx={{ textTransform: "initial" }}>
                            {props.trainingName}{props.classroomName && <>&nbsp;&bull;&nbsp;{props.classroomName}</>}
                        </Typography>
                    </>
                }
                shrinkPadding
                onClose={onClose}
            />
            <DialogContent>
                <ClassroomDiscussionBox
                    dialogMode
                    onUpdateCommentCounter={onUpdateCommentCounter}
                    discussionMode="instructor"
                    {...rest}
                />
            </DialogContent>
        </Dialog>
    );
};
